import {API_URL, apiGet} from '../api'
import {ApiRes} from '../../types/api'

export type UserBadgeStatus = 'active' | 'expired' | 'revoked'

// 어드민 전체조회 엔드포인트(GET /v3/admin/user-badges) 응답의 한 행.
// 공개 엔드포인트(users/:id/badges)와 달리 이미지/다국어 이름이 없고,
// badge_name은 영어 고정 + status 문자열로 만료/회수를 표현한다.
// 정렬은 서버에서 granted_at 내림차순 고정, page_info 없음(total 미제공).
export interface IAdminUserBadge {
    id: string // user-badge assignment ID
    user_id: string
    badge_id: string // 배지 템플릿 ID
    badge_name: string // 영어 고정 (다국어는 카탈로그 조인 필요)
    badge_code: string
    badge_type: string // 'limited' | 'permanent'
    category: string
    granted_at: number // unix sec
    granted_by: string
    expired_at?: number // 영구 배지면 키 자체가 없음
    revoked_at?: number // 회수 안 됐으면 키 없음
    revoked_by?: string // 회수 안 됐으면 키 없음
    is_displayed: boolean
    status: UserBadgeStatus // 'active' | 'expired' | 'revoked'
}

export interface IAdminUserBadgeFilter {
    user_id?: string
    badge_id?: string
    status?: UserBadgeStatus
    limit?: number // 기본·최대 500
    skip?: number
}

export const ADMIN_USER_BADGE_DEFAULT_LIMIT = 100

export const getAdminUserBadges = async (
    filter: IAdminUserBadgeFilter = {},
): Promise<ApiRes<IAdminUserBadge[]>> => {
    const params = new URLSearchParams()
    if (filter.user_id) params.set('user_id', filter.user_id)
    if (filter.badge_id) params.set('badge_id', filter.badge_id)
    if (filter.status) params.set('status', filter.status)
    params.set('limit', String(filter.limit ?? ADMIN_USER_BADGE_DEFAULT_LIMIT))
    params.set('skip', String(filter.skip ?? 0))
    return await apiGet(API_URL, `admin/user-badges?${params.toString()}`)
}
